import { render, staticRenderFns } from "./referral-view-email.vue?vue&type=template&id=ab535eee&scoped=true&"
import script from "./referral-view-email.vue?vue&type=script&lang=js&"
export * from "./referral-view-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab535eee",
  null
  
)

export default component.exports